import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import TimeInput from "react-time-picker-input";
import { diasOptions } from "../utils/utils";
import moment from "moment";

const { Select2, Date, DateTime, Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];
function AddAmbiente({ history, match }) {
  const dispatch = useDispatch();

  const modelAddAmbiente = useSelector((state) => state.addAmbiente);

  const [nombre, setNombre] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");
  const [localId, setLocalId] = useState(
    match.params.localId ? match.params.localId : null
  );
  const [diasSeleccionados, setDiasSeleccionados] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    7: true,
  });
  const [maxPersonas, setMaxPersonas] = useState(10);

  useEffect(() => {
    const data = modelAddAmbiente?.data?.data;
    const error = modelAddAmbiente?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckAddAmbiente.actions.clear());
    }
    if (data) {
      history.push(
        !match.params.localId
          ? "/locales"
          : `/ambientes/${match.params.localId}`
      );
      dispatch(controller.duckAddAmbiente.actions.clear());
    }
  }, [modelAddAmbiente]);

  function submit() {
    const diasArray = Object.values(diasSeleccionados);
    if (!nombre || !estado || !maxPersonas || diasArray.length === 0) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (!localId) {
      alert("No se ha podido obtener el ID del local");
      return;
    }

    let data = {
      nombre,
      estado,
      maxPersonas,
      localId,
      diasSemana: diasArray,
    };

    dispatch(controller.cargarAmbienteThunk(data));
  }

  function handleDias(dia, value) {
    let newDias = {
      1: diasSeleccionados[1],
      2: diasSeleccionados[2],
      3: diasSeleccionados[3],
      4: diasSeleccionados[4],
      5: diasSeleccionados[5],
      6: diasSeleccionados[6],
      7: diasSeleccionados[7],
    };
    newDias[dia] = value;
    setDiasSeleccionados(newDias);
  }

  return (
    <Content title="Nuevo ambiente" browserTitle="Nuevo ambiente" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nuevo ambiente"
            footer={
              <>
                <Button
                  text="Cancelar"
                  onClick={() => history.goBack()}
                />

                <Button
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  disabled={modelAddAmbiente.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Nombre"
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              inputType="number"
              label="Maximo de personas"
              value={maxPersonas}
              onChange={(evt) => setMaxPersonas(evt.target.value)}
            />

            <Col md="12">
              <text>
                <strong>Dias</strong>
              </text>
            </Col>

            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[1] === true ? "success" : "default"}
                text="Lunes"
                onClick={() =>
                  handleDias(1, diasSeleccionados[1] === true ? false : true)
                }
              />
            </Col>
            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[2] === true ? "success" : "default"}
                text="Martes"
                onClick={() =>
                  handleDias(2, diasSeleccionados[2] === true ? false : true)
                }
              />
            </Col>
            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[3] === true ? "success" : "default"}
                text="Miercoles"
                onClick={() =>
                  handleDias(3, diasSeleccionados[3] === true ? false : true)
                }
              />
            </Col>

            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[4] === true ? "success" : "default"}
                text="Jueves"
                onClick={() =>
                  handleDias(4, diasSeleccionados[4] === true ? false : true)
                }
              />
            </Col>

            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[5] === true ? "success" : "default"}
                text="Viernes"
                onClick={() =>
                  handleDias(5, diasSeleccionados[5] === true ? false : true)
                }
              />
            </Col>
            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[6] === true ? "success" : "default"}
                text="Sabado"
                onClick={() =>
                  handleDias(6, diasSeleccionados[6] === true ? false : true)
                }
              />
            </Col>

            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[7] === true ? "success" : "default"}
                text="Domingo"
                onClick={() =>
                  handleDias(7, diasSeleccionados[7] === true ? false : true)
                }
              />
            </Col>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddAmbiente;
